







































import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import ErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ErrorDialog,
    TitleSection,
  },
})
export default class SignupPageWithTitleSection extends Mixins<WithErrorModal>(WithErrorModal) {
  @Prop({ default: '/s/mypage' })
  /**
   * @see SignupPageProps.next
   */
  readonly next: string

  @Prop({ default: '/login' })
  /**
   * @see SignupPageProps.loginLink
   */
  readonly loginLink: string

  @Prop({ default: '会員登録' })
  /**
   * @see SignupPageProps.title
   */
  readonly title: string
}
